import React from 'react';
import { styled } from '@goodrx/matisse';
import AppLogo from 'app/components/AppLogo/AppLogo';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
  margin-top: 32px;
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 560px;
`;

const Title = styled.h1`
  color: #303b52;
  font-size: 24px;
  text-decoration: bold;
  margin: 24px auto 0px;
`;

const Description = styled.p`
  font-size: 20px;
  max-width: 486px;
  text-align: center;
`;

export default function UnsupportedBrowser() {
  return (
    <Wrapper id="wrapper">
      <Main>
        <AppLogo />

        <Title>Shoot, we don&apos;t support this Internet browser!</Title>
        <Description>
          It looks like you are using an unsupported browser. In order to complete your online visit, we recommend using
          the Safari, Chrome, or Firefox browser on your desktop or smartphone.
        </Description>
      </Main>
    </Wrapper>
  );
}
